import requestUtils from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-business'

/**
 * Unified item-policy evaluation endpoint. Send items with a `cost` for a full verdict + credit,
 * or omit `cost` for a budget-only line (the credit fields come back null). The response is keyed
 * by the client-provided `item.key`.
 */
export type ItemPolicyEvaluateRequestWire =
  paths['/api/business-traveller/businesses/{businessId}/item-policies/evaluate']['post']['requestBody']['content']['application/json']

type ItemPolicyEvaluateServerResponseWire =
  paths['/api/business-traveller/businesses/{businessId}/item-policies/evaluate']['post']['responses'][200]['content']['application/json']

/** Map of item key -> per-item evaluation result. */
export type ItemPolicyEvaluateResultWire = ItemPolicyEvaluateServerResponseWire['result']

/** A single item's evaluation result: rows plus the budget-bar presenter blocks. */
export type ItemPolicyEvaluateItemResultWire = ItemPolicyEvaluateResultWire[string]

/** A single evaluation item in the request body (hotel | flight | car hire). */
export type ItemPolicyEvaluateItemInputWire = ItemPolicyEvaluateRequestWire['items'][number]

async function requestPostItemPolicyEvaluate(
  businessId: string,
  body: ItemPolicyEvaluateRequestWire,
): Promise<ItemPolicyEvaluateResultWire> {
  const response = await requestUtils.post<ItemPolicyEvaluateServerResponseWire, ItemPolicyEvaluateRequestWire>(
    `/api/business-traveller/businesses/${businessId}/item-policies/evaluate?without_brand=1`,
    body,
    { credentials: 'include' },
  )

  if (!response.result) {
    throw new Error('Could not evaluate item policies!')
  }

  return response.result
}

export default requestPostItemPolicyEvaluate
